import { render } from "./UserLimits.vue?vue&type=template&id=5129ca91"
import script from "./UserLimits.vue?vue&type=script&lang=js"
export * from "./UserLimits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__